export default {
  STATUS: [
    { KEY: 0, VALUE: 'ATIVO' },
    { KEY: 1, VALUE: 'BLOQUEADO' },
  ],
  TYPE: [
    { KEY: 0, VALUE: 'WEB' },
    { KEY: 1, VALUE: 'APP' },
    { KEY: 2, VALUE: 'POS' },
  ],
  TRANSACTION_TYPES: [
    { KEY: 0, VALUE: 'CRÉDITO EM CONTA' },
    { KEY: 1, VALUE: 'VENDA DE PASSAGEM' },
    { KEY: 2, VALUE: 'BAIXA MOTORISTA' },
    { KEY: 3, VALUE: 'ESTORNO' },
    { KEY: 4, VALUE: 'TROCA DE PASSAGEM' },
    { KEY: 5, VALUE: 'VENDA DE PRODUTO' },
    { KEY: 6, VALUE: 'PASSAGEM RESERVADA' },
    { KEY: 7, VALUE: 'TROCO' },
    { KEY: 8, VALUE: 'EMISSÃO DE PASSAGEM' },
    { KEY: 9, VALUE: 'SANGRIA' },
    { KEY: 10, VALUE: 'REAGENDAMENTO DE PASSAGEM' },
    { KEY: 11, VALUE: 'CANCELAMENTO DE PASSAGEM' },
    { KEY: 12, VALUE: 'EMPRESA' },
    { KEY: 13, VALUE: 'CANCELAMENTO (PRODUTOS)' },
    { KEY: 14, VALUE: 'CONSULTA DE SALDO' },
  ],
};

const CONST_SELLING_POINTS_OBJECT = {
  STATUS: {
    ACTIVE: { KEY: 0, VALUE: 'ATIVO' },
    BLOCKED: { KEY: 1, VALUE: 'BLOQUEADO' },
  },
  TYPE: {
    WEB: { KEY: 0, VALUE: 'WEB' },
    APP: { KEY: 1, VALUE: 'APP' },
    POS: { KEY: 2, VALUE: 'POS' },
  },
  TRANSACTION_TYPES: {
    CHARGE: { KEY: 0, VALUE: 'CRÉDITO EM CONTA' },
    TOKEN: { KEY: 1, VALUE: 'VENDA DE PASSAGEM' },
    EMPLOYEE: { KEY: 2, VALUE: 'BAIXA MOTORISTA' },
    RETURN: { KEY: 3, VALUE: 'ESTORNO' },
    CHANGE_TOKEN: { KEY: 4, VALUE: 'TROCA DE PASSAGEM' },
    PRODUCT: { KEY: 5, VALUE: 'VENDA DE PRODUTO' },
    BOOKED_TOKEN: { KEY: 6, VALUE: 'PASSAGEM RESERVADA' },
    CHANGE: { KEY: 7, VALUE: 'TROCO' },
    BOOKED_TOKEN_EMISSION: { KEY: 8, VALUE: 'EMISSÃO DE PASSAGEM' },
    WITHDRAW: { KEY: 9, VALUE: 'SANGRIA' },
    BOOKED_TOKEN_RESCHEDULE: { KEY: 10, VALUE: 'REAGENDAMENTO DE PASSAGEM' },
    CANCEL_TOKEN: { KEY: 11, VALUE: 'CANCELAMENTO DE PASSAGEM' },
    COMPANY: { KEY: 12, VALUE: 'EMPRESA' },
    CANCEL_PRODUCT: { KEY: 13, VALUE: 'CANCELAMENTO (PRODUTOS)' },
    BALANCE_CHECK: { KEY: 14, VALUE: 'CONSULTA DE SALDO' },
  },
  RULE_TYPE: [
    { KEY: 0, VALUE: 'NORMAL' },
    { KEY: 1, VALUE: 'SUPERVISOR' },
  ],
};

export { CONST_SELLING_POINTS_OBJECT };
